import { isPlainObject, mergeWith } from 'lodash';
import DEFAULT_SECTIONS from '@/components/Dashboard/constants/defaultSections';

function structuredCloneSafe(value) {
  if (typeof structuredClone === 'function') return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

export function reconcileStructures(
  response,
  baseStructure = DEFAULT_SECTIONS
) {
  if (!isPlainObject(baseStructure)) return {};
  if (!isPlainObject(response)) return structuredCloneSafe(baseStructure);

  const baseClone = structuredCloneSafe(baseStructure);

  return mergeWith(baseClone, response, (objValue, srcValue) => {
    if (srcValue == null) return objValue;
    if (Array.isArray(srcValue)) return srcValue;

    return undefined;
  });
}

// Asume reconciled structure
export function buildBackendStructureTabs(
  frontendTabs,
  { onlyIncludeDirty = false } = {}
) {
  const backendTabs = {};

  Object.entries(frontendTabs).forEach((tabEntry) => {
    const [tabId, tabFields] = tabEntry;
    const { order: tabOrder, visible: tabVisible, sections } = tabFields;
    const backendSections = {};

    sections.forEach((section) => {
      const {
        id: sectionId,
        order: sectionOrder,
        visible: sectionVisible,
        cards,
      } = section;
      const backendCards = {};

      cards.forEach((card) => {
        const {
          id: cardId,
          order: cardOrder,
          visible: cardVisible,
          expanded: cardExpanded,
        } = card;

        backendCards[cardId] = {
          order: cardOrder,
          visible: cardVisible,
          expanded: cardExpanded,
        };
      });

      if ((onlyIncludeDirty && section.dirty) || !onlyIncludeDirty) {
        backendSections[sectionId] = {
          order: sectionOrder,
          visible: sectionVisible,
          ...backendCards,
        };
      }
    });

    if (Object.keys(backendSections).length > 0) {
      backendTabs[tabId] = {
        order: tabOrder,
        visible: tabVisible,
        ...backendSections,
      };
    }
  });

  return backendTabs;
}

// Asume reconciled structure
export function buildFrontendStructureTabs(backendTabs = {}) {
  const frontendTabs = {};

  Object.entries(backendTabs).forEach((tabEntry) => {
    const [tabId, tabFields] = tabEntry;
    const { order: tabOrder, visible: tabVisible, ...sections } = tabFields;
    const frontendSections = [];

    Object.entries(sections).forEach((sectionEntry) => {
      const [sectionId, sectionFields] = sectionEntry;
      const {
        order: sectionOrder,
        visible: sectionVisible,
        ...cards
      } = sectionFields;
      const frontendCards = [];

      Object.entries(cards).forEach((cardEntry) => {
        const [cardId, cardFields] = cardEntry;
        const {
          order: cardOrder,
          visible: cardVisible,
          expanded: cardExpanded,
          alwaysExpanded = false,
        } = cardFields;

        frontendCards.push({
          id: cardId,
          order: cardOrder,
          visible: cardVisible,
          expanded: cardExpanded,
          alwaysExpanded,
        });
      });

      frontendSections.push({
        id: sectionId,
        order: sectionOrder,
        visible: sectionVisible,
        cards: frontendCards,
      });
    });

    frontendTabs[tabId] = {
      order: tabOrder,
      visible: tabVisible,
      sections: frontendSections,
    };
  });

  return frontendTabs;
}
